import { api } from "@/api/client";
import type { User } from "@/types";

export async function fetchUsers(): Promise<User[]> {
  const { data } = await api.get<User[]>("/users");
  return data;
}

export async function createUser(input: { email: string; name?: string }): Promise<User> {
  const { data } = await api.post<User>("/users", input);
  return data;
}

export async function setUserActive(id: number, active: boolean): Promise<User> {
  const { data } = await api.patch<User>(`/users/${id}`, { active });
  return data;
}
